import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Info } from 'lucide-react';
import { metricContextMap } from '@/data/metric-context';

export function MetricTooltip({ metricKey }: { metricKey: string }) {
  const ctx = metricContextMap[metricKey];
  if (!ctx) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className="text-muted-foreground h-4 w-4 cursor-help" />
        </TooltipTrigger>
        <TooltipContent
          className="max-w-sm space-y-2 rounded-lg border p-4 shadow-lg"
          style={{
            backgroundColor: 'var(--card)',
            color: 'var(--foreground)',
            borderColor: 'var(--border)',
          }}
          side="top"
        >
          <p className="font-medium">{ctx.label}</p>
          <p className="text-muted-foreground text-sm">{ctx.description}</p>
          <p className="text-sm" style={{ color: 'var(--status-success-fg)' }}>
            <span className="font-medium">Healthy:</span> {ctx.healthyBaseline}
          </p>
          <p className="text-sm" style={{ color: 'var(--status-warning-fg)' }}>
            <span className="font-medium">Watch for:</span> {ctx.warning}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
